export type DraftSaveGuard = {
  isDirty: () => boolean;
  save: () => Promise<void>;
};

let currentGuard: DraftSaveGuard | null = null;

export function setDraftSaveGuard(guard: DraftSaveGuard | null) {
  currentGuard = guard;
}

export async function runDraftSaveIfNeeded() {
  const guard = currentGuard;
  if (!guard) return;
  if (!guard.isDirty()) return;
  await guard.save();
}


